const ETAPAS = {
  RISCO: "RISCO",
  VEICULOS: "VEICULOS",
  COBERTURA: "COBERTURA"
};

const DESTINOS = {
  GRID_PRINCIPAL: "GRID_PRINCIPAL",
  INFO_GERAIS: "INFO_GERAIS",
  RISCO: "RISCO"
};

function etapaAnteriorIncompleta(estado) {
  if (!estado.conteudoInfoGeraisValido) {
    return estado.conteudoPlanilhaValido
      ? DESTINOS.INFO_GERAIS
      : DESTINOS.GRID_PRINCIPAL;
  }
  return DESTINOS.RISCO;
}

function proximaRotaWizard(etapa, estado) {
  if (etapa === ETAPAS.RISCO) {
    if (!estado.conteudoInfoGeraisValido && !estado.copiaParcialSemItens) {
      return estado.conteudoPlanilhaValido
        ? DESTINOS.INFO_GERAIS
        : DESTINOS.GRID_PRINCIPAL;
    }
    return null;
  }

  if (etapa === ETAPAS.VEICULOS && estado.copiaParcialSemItens) {
    return estado.riscosPreenchidos ? null : DESTINOS.RISCO;
  }

  if (!estado.conteudoRiscosValido) {
    return etapaAnteriorIncompleta(estado);
  }

  return null;
}

const CAMINHOS = {
  GRID_PRINCIPAL: "/GridPrincipal",
  INFO_GERAIS: "/GridPrincipal/InfoGerais",
  RISCO: "/GridPrincipal/Risco"
};

function rotaWizard(destino, idApolice) {
  const caminho = CAMINHOS[destino];
  if (destino === DESTINOS.GRID_PRINCIPAL || !idApolice) {
    return caminho;
  }
  return `${caminho}?id=${idApolice}`;
}

export default { ETAPAS, DESTINOS, CAMINHOS, proximaRotaWizard, rotaWizard };



// WEBPACK FOOTER //
// ./src/helpers/wizard-cotacao.js